import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import SettingsBrightnessOutlinedIcon from '@mui/icons-material/SettingsBrightnessOutlined';
import {MODES, useThemeMode} from './ThemeMode';

const ICONS = {
    auto: SettingsBrightnessOutlinedIcon,
    light: LightModeOutlinedIcon,
    dark: DarkModeOutlinedIcon
};

const LABELS = {
    auto: 'Theme: follow system',
    light: 'Theme: light',
    dark: 'Theme: dark'
};

export default function ThemeToggle() {
    const {mode, setMode} = useThemeMode();
    const Icon = ICONS[mode];

    function cycle() {
        setMode(MODES[(MODES.indexOf(mode) + 1) % MODES.length]);
    }

    return (
        <Tooltip title={`${LABELS[mode]} (click to change)`} placement="left">
            <IconButton
                onClick={cycle}
                size="small"
                aria-label={LABELS[mode]}
                className="ThemeToggleButton"
            >
                <Icon fontSize="small"/>
            </IconButton>
        </Tooltip>
    );
}
